import React, { useState, useEffect, useRef } from 'react';
import Hamburger from './components/Hamburger';
import Home from './Sections/Home';
// import Contact from './Sections/Contact';
import About from './Sections/About';
import Internships from './Sections/Internships';
import Faqs from './Sections/Faqs';
import './Styles.css'
import scrollToTop from "./assets/back-to-top.png"
import CardsWrapper from './Sections/CardsWrapper';
import Footer from './Sections/Footer';
import logo from "./assets/Logo.png"
import { Link } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import DropdownNav from './components/DropdownNav';

const App = () => {
  const { isAuthenticated, loginWithRedirect, user } = useAuth0();
  const [showNavbar, setShowNavbar] = useState(false)

  console.log(user, "useruser")
  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };
  // const [currentSection, setCurrentSection] = useState('home')
  const sectionRefs = {
    home: useRef(null),
    about: useRef(null),
    internships: useRef(null),
    faqs: useRef(null),
    // contact: useRef(null)
  };

  const handleNavigation = (section) => {
    // setCurrentSection(section);
    sectionRefs[section].current.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScroll = () => {
    for (const [ref] of Object.entries(sectionRefs)) {
      if (ref.current && isElementInViewport(ref.current)) {
        // setCurrentSection(section);
        break;
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, []);

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <nav className="navbar">
        <div className="container">
          <div className="logo">
            <Link to="/"><img src={logo} className='logo-img' alt="#" /></Link>
            <Link to="/" className='interncrafters'><h4>Intern Crafters</h4></Link>
          </div>
          <div className="menu-icon" onClick={handleShowNavbar}>
            <Hamburger />
          </div>
          <div className={`nav-elements  ${showNavbar && "active"}`}>
            <ul>
              <li><button className="nav-items-btn" onClick={() => handleNavigation('home')}>Home</button></li>
              <li><button className="nav-items-btn" onClick={() => handleNavigation('about')}>About</button></li>
              <li><button className="nav-items-btn" onClick={() => handleNavigation('internships')}>Internships</button></li>
              <li><button className="nav-items-btn" onClick={() => handleNavigation('faqs')}>FAQs</button></li>
              <Link to="/courses"><li><button className="nav-items-btn">Courses</button></li></Link>
              {isAuthenticated ? <DropdownNav isHam={false} username={user.name} /> : <li><button style={{ fontWeight: "bold" }} className="nav-items-btn" onClick={() => loginWithRedirect()}>Log In</button></li>}
            </ul>
          </div>
        </div>
      </nav>
      <main className='appWrapper'>
        <Home ref={sectionRefs.home} />
        <CardsWrapper ref={sectionRefs.about} />
        <About ref={sectionRefs.about} />
        <Internships ref={sectionRefs.internships} />
        <Faqs ref={sectionRefs.faqs} />
        {/* <Contact ref={sectionRefs.contact} /> */}
      </main>
      <button onClick={handleScrollToTop} style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: '999' }}>
        <img src={scrollToTop} className='scrolltotop' alt="#" />
      </button>
      <Footer handleNavigation={handleNavigation} />
    </div>
  );
};

export default App;
